class BundleCartMain extends HTMLElement {
  constructor() {
    super();
    this.bundler = document.getElementById("bundle-cart-bundler");

    this.images = document.querySelectorAll("img[data-bundle-image-id]");
    this.listItems = this.querySelectorAll(`[data-bundle-card-id]`);
    this.shadowProductNode = document.getElementById(
      "bundle-progress__item-shadow"
    );

    this.bundleControlElements = document.querySelectorAll(
      ".bundle-item-control"
    );
    [...this.bundleControlElements].forEach((bundleControlElement) => {
      const addButton = bundleControlElement.querySelector(".add-to-bundle");
      addButton.addEventListener("click", () => {
        this.addItem(addButton);
      });
      const removeButton = bundleControlElement.querySelector(
        ".remove-from-bundle"
      );
      removeButton.addEventListener("click", () => {
        this.removeFromBundle(addButton);
      });
    });
    this.cardDrawerPointer = document.querySelector("cart-drawer");
    this.observer = null;
  }

  connectedCallback() {
    // Set up the MutationObserver to detect class changes on cardDrawerPointer
    if (this.cardDrawerPointer) {
      this.observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "class"
          ) {
            const hasActiveClass =
              this.cardDrawerPointer.classList.contains("active");
            if (hasActiveClass) {
              this.bundler.style.zIndex = 1;
            } else {
              this.bundler.style.zIndex = null;
            }
          }
        }
      });

      // Start observing cardDrawerPointer for class changes
      this.observer.observe(this.cardDrawerPointer, {
        attributes: true,
        attributeFilter: ["class"],
        attributeOldValue: true, // Add this to track old values
        subtree: false // Explicitly set to false since we only care about the root element
      });
    } else {
      console.error("cardDrawerPointer element not found.");
    }
  }
  disconnectedCallback() {
    // Clean up the observer when the element is removed from the DOM
    console.log("disconnect");
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  updateQuantity(elementsArray) {
    const map = new Map();
    map.set("default", "0");
    elementsArray.forEach((str) => {
      if (map.has(str.id)) {
        map.set(str.id, map.get(str.id) + 1);
      } else {
        map.set(str.id, 1);
      }
    });
    let total = 0;
    for (let key of map.keys()) {
      total = total + Number(map.get(key));
    }
    [...this.bundleControlElements].forEach((bundleControlElement) => {
      const elementDataId =
        bundleControlElement.getAttribute("data-product-id");
      const removeButton = bundleControlElement.querySelector(
        ".remove-from-bundle"
      );
      const addButton = bundleControlElement.querySelector(".add-to-bundle");
      const matchingElement = [...this.listItems].find(
        (el) => el.getAttribute("data-bundle-card-id") === elementDataId
      );
      const found = map.get(elementDataId);
      if (total > 0 && total < 5) {
        if (matchingElement && found) {
          matchingElement.classList.add("in-the-bundle");
        }
        addButton.classList.remove("disable");
        removeButton.classList.remove("disable");
      }
      if (total === 5) {
        if (found) {
          if (matchingElement && found) {
            matchingElement.classList.add("in-the-bundle");
          }
          addButton.classList.add("disable");
          removeButton.classList.remove("disable");
        } else {
          addButton.classList.add("disable");
          removeButton.classList.add("disable");
        }
      }
      if (!total || total === 0) {
        if (matchingElement) {
          matchingElement.classList.remove("in-the-bundle");
        }
        addButton.classList.remove("disable");
        removeButton.classList.add("disable");
      }
      if (matchingElement && !found) {
        matchingElement.classList.remove("in-the-bundle");
        removeButton.classList.add("disable");
      }
      const bundleItemCount =
        bundleControlElement.querySelector(".bundle-item-count");
      bundleItemCount.innerText = found | 0;
    });
  }

  addItem(bundleButton) {
    const card = document.querySelector("bundle-cart");
    const result = card.addToBundle(bundleButton);
    this.updateQuantity(result);
  }
  removeFromBundle(bundleButton) {
    const card = document.querySelector("bundle-cart");
    const result = card.removeFromBundle(bundleButton);
    this.updateQuantity(result);
  }
}

customElements.define("bundle-cart-main", BundleCartMain);

class BundleCart extends HTMLElement {
  constructor() {
    super();
    this.bundleHeaderMobile = document.getElementById(
      "bundle-progress__header-mobile"
    );
    this.bundleFreeItem = document.getElementById("bundle-target-item");
    this.bundleProgressContainer = document.getElementById(
      "bundle-progress-container"
    );
    this.bundleProgressContainerFooter = document.getElementById(
      "bundle-progress-container-footer"
    );
    this.bundleAddToCartButton = document.getElementById("add-to-cart-button");
    this.parent = document.querySelector("bundle-cart-main");
    this.progressItems = document.querySelectorAll(".bundle-progress__item");
    this.progressBarItems = document.querySelectorAll(
      ".bundle-progress-bar__item"
    );
    this.progressBarItemsParent = document.getElementById("bundleProgressBar");
    this.progressItemsContainer = document.querySelector(
      ".bundle-progress__items"
    );
    this.dataBundleButtonCaption = document.querySelector(
      "[data-bundle-button-caption]"
    );
    this.dataBundleButtonPrice = document.querySelector(
      "[data-bundle-button-price]"
    );
    this.dataBundleTotalAmount = document.querySelector(
      "[data-bundle-total-amount]"
    );
    this.currentItem = this.progressBarItems[0];
    this.buttons = document.getElementById("product-grid1");

    this.shadowLi = document.querySelector("#bundle-progress__item-shadow");
    this.shadowNodeCardContent = document.getElementById(
      "shadowNodeCardContent"
    );
    this.bundleMainContent = document.getElementById("bundle-main-content");
    this.addClickEvents();

    this.itemsIdsInBundle = [];
    this.toFooter = true;
    this.mediaQuery = window.matchMedia("(max-width: 1169px)");
    this.handleScreenChange(this.mediaQuery);
    this.mediaQuery.addEventListener("change", (e) => {
      this.handleScreenChange(e);
    });
    this.bundleHeaderMobile.addEventListener("click", () => {
      const svgIcon = this.bundleHeaderMobile.querySelector(
        ".bundle-progress__mobile-icon-svg"
      );
      const title = this.bundleHeaderMobile.querySelector(
        ".bundle-progress__header-mobile__title"
      );
      if (title) {
        const closedTitle = "View My Bundle";
        const openedTitle = "Close My Bundle";
        title.innerText =
          title.innerText === closedTitle ? openedTitle : closedTitle;
      }
      if (svgIcon) {
        svgIcon.classList.toggle("down");
      }
      this.bundleMainContent.classList.toggle("hide");
    });
    this.bundleAddToCartButton.addEventListener("click", async () => {
      this.bundleAddToCartButton.setAttribute("disabled", true);
      this.bundleAddToCartButton.classList.remove("active");
      await this.handleSubmit();
    });

    this.unlockTexts = {
      gift: this.getAttribute('data-unlock-free-gift') || 'Unlock a free gift'
    };

    this.discountRates = {
      two: parseFloat(this.getAttribute('data-discount-two')) || 0.10,
      three: parseFloat(this.getAttribute('data-discount-three')) || 0.15,
      four: parseFloat(this.getAttribute('data-discount-four')) || 0.20
    };
    this.freeShippingPrice = parseFloat(this.getAttribute('data-free-shipping-price')) || 110;
    this.shippingRate = parseFloat(this.getAttribute('data-shipping-rate')) || 9.9;
  }

  calculateDiscount(itemCount) {
    if (itemCount >= 4) return this.discountRates.four;
    if (itemCount >= 3) return this.discountRates.three;
    if (itemCount >= 2) return this.discountRates.two;
    return 0;
  }

  async handleSubmit() {
    const bundleId = String(new Date().getTime());
    const itemsCount = this.itemsIdsInBundle.reduce((acc, item) => {
      if (acc[item.id]) {
        acc[item.id].quantity += 1; // Increment quantity if ID already exists
      } else {
        acc[item.id] = {
          id: item.id,
          quantity: 1,
          properties: { _bundleId: bundleId, _isFull: false },
        };
      }
      return acc;
    }, {});
    if (this.itemsIdsInBundle.length === 5) {
      const freeItemId = this.bundleFreeItem.getAttribute("data-product-id");
      if (freeItemId) {
        itemsCount["freeItem"] = {
          id: freeItemId,
          quantity: 1,
          properties: { _bundleId: bundleId, _isFull: true },
        };
      }
    }

    // Convert the itemsCount object to an array
    const itemsPayload = Object.values(itemsCount);

    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: itemsPayload,
      }),
      cache: "reload"
    });
    await fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const targetElement = document.querySelector("#cart-icon-bubble");
        const sourceElement = html.querySelector(
          "#shopify-section-cart-icon-bubble"
        );
        if (targetElement && sourceElement) {
          targetElement.innerText = sourceElement.innerText;
        }
      });
    await fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const selectors = [
          "cart-drawer",
          "cart-drawer-items",
          ".cart-drawer__footer",
        ];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .then(() => {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.classList.add("animate");
          setTimeout(() => {
            cartDrawer.classList.add("active");
          }, 500);
          this.parent.style.zIndex = 1;
          this.style.zIndex = 1;
        }
        this.handleReset();
        window.location = '/checkout';
      });
  }
  handleScreenChange(e) {
    if (e.matches) {
      // If screen width is 1169px or less, move progress bar to footer

      this.moveProgressBarToFooter();
    } else {
      // If screen width is greater than 1169px, move it back to main
      this.moveProgressBarToMain();
    }
  }
  moveProgressBarToFooter() {
    this.bundleProgressContainerFooter.appendChild(this.progressBarItemsParent);
  }
  moveProgressBarToMain() {
    this.bundleProgressContainer.insertBefore(
      this.progressBarItemsParent,
      this.bundleProgressContainer.firstElementChild
    );
  }
  handleReset() {
    // Clear the items in the bundle
    this.bundleAddToCartButton.removeAttribute("disabled");
    this.itemsIdsInBundle = [];

    // Reset all elements to their default state
    this.progressItemsContainer.innerHTML = ""; // Clear the bundle progress container
    this.progressBarItems.forEach((item) => item.classList.remove("active")); // Deactivate all progress bar items

    // Recreate the initial empty bundle progress items
    const newNodesArr = [];
    while (newNodesArr.length < 5) {
      const clone = this.shadowLi.cloneNode(true);
      const variantNode = clone.querySelector(".product-variant-name");
      const priceNode = clone.querySelector(".product-variant-price");
      const freeGiftNode = clone.querySelector(".free-gift");
  
      if (priceNode) priceNode.remove();
      if (variantNode) variantNode.remove();

      clone.classList.add("h-20", "bundle-progress__item", "flex");
      clone.removeAttribute("id");
      clone.removeAttribute("style");
  
      const position = newNodesArr.length;
      if (freeGiftNode) {
        if (position === 0) {
          freeGiftNode.remove();
        } else if (position === 1) {
          freeGiftNode.textContent = `Unlock ${this.discountRates.two * 100}% off`;
        } else if (position === 2) {
          freeGiftNode.textContent = `Unlock ${this.discountRates.three * 100}% off`;
        } else if (position === 3) {
          freeGiftNode.textContent = `Unlock ${this.discountRates.four * 100}% off`;
        }
      }
  
      newNodesArr.push(clone);
    }
  
    // Append the reset nodes to the progress container
    newNodesArr.forEach((node) => this.progressItemsContainer.appendChild(node));
  
    // Reset the progress bar to its initial state
    const beforeTail = document.querySelector(".before-tail");
    if (beforeTail) beforeTail.remove();
    this.progressBarItems = document.querySelectorAll(".bundle-progress-bar__item");
  
    // Reset the cart button and captions
    this.dataBundleButtonCaption.innerText = "Select your items";
    this.dataBundleButtonPrice.innerText = "$0.00 AUD";
    this.dataBundleTotalAmount.innerHTML = "";
    this.bundleAddToCartButton.classList.remove("active");
  
    this.adjustTransitions(-1, false);
    this.parent.updateQuantity([]);
  }

  adjustTransitions(idx, forwards) {
    const currentProgressElements = [...this.progressBarItems];
    if (currentProgressElements.length <= 6) {
      currentProgressElements.forEach((el, index) => {
        if (!forwards) {
          if (index === currentProgressElements.length - 1) {
            el.style.transitionDelay = "0s";
            el.classList.add("active");
          }
          if (index === currentProgressElements.length - 2) {
            el.style.transitionDelay = "0.2s";
            el.classList.add("active");
          }
        }

        if (index <= idx) {
          el.classList.add("active");
        } else {
          el.classList.remove("active");
        }
      });
    } else {
      currentProgressElements.forEach((el, index) => {
        if (index === 4) {
          el.classList.add("active");
        }
        if (index === 5) {
          setTimeout(() => {
            el.style.transitionDelay = "0.2s";
            el.classList.add("active");
          }, 200);
        }
        if (index === 6) {
          el.style.transitionDelay = "0.6s";
          el.classList.add("active");
        }
      });
    }
  }
  addClickEvents() {}

  handleProgressItemClick(event, index) {
    event.stopPropagation();

    for (let i = 0; i < this.progressItems.length; i++) {
      const removeBtn = this.progressItems[i].querySelector(
        ".bundle-progress__item__remove"
      );

      const isTarget = removeBtn.contains(event.target);

      if (isTarget) {
        this.removeItemByIndex(i);
        return; // Ensure we stop if an item is removed
      }
    }
  }

  addToBundle(buttonElement) {
    const index = this.itemsIdsInBundle.length;

    if (index === 5) {
      return this.itemsIdsInBundle;
    }
    const id = buttonElement.getAttribute("data-product-id");
    this.itemsIdsInBundle.push({ id, buttonElement });
    const newNodesArr = [];
    this.itemsIdsInBundle.forEach((node, index) => {
      const clone = this.shadowLi.cloneNode(true);
      const title = node.buttonElement.getAttribute("data-product-title");
      const imageUrl = node.buttonElement.getAttribute("data-product-image-url");
      const productVariantName = node.buttonElement.getAttribute("data-product-variant-name");
      const productPrice = node.buttonElement.getAttribute("data-product-price");
      
      const productVariantNode = clone.querySelector(".product-variant-name");
      const productVariantPriceNode = clone.querySelector(".product-variant-price");
      const freeGiftNode = clone.querySelector(".free-gift");
      const discount = this.itemsIdsInBundle.length >= 4 ? this.discountRates.four : 
                      this.itemsIdsInBundle.length >= 3 ? this.discountRates.three :
                      this.itemsIdsInBundle.length >= 2 ? this.discountRates.two : 0;
  
      const originalPrice = parseFloat(productPrice.replace(/[^\d.-]/g, ""));
      const discountedPrice = originalPrice * (1 - discount);
      const currencySymbol = productPrice[0];
      const currencyCode = productPrice.split(" ").pop();
  
      if (discount > 0) {
        productVariantPriceNode.innerHTML = `
          <span class="font-extralight text-base line-through text-gray-400">${productPrice}</span>
          <span class="font-extralight text-base">${currencySymbol}${discountedPrice.toFixed(2)} ${currencyCode}</span>
        `;
      } else {
        productVariantPriceNode.innerText = productPrice;
      }
  
      if (productVariantName) {
        productVariantNode.innerText = productVariantName;
      } else {
        productVariantNode.remove();
      }
      
      const firstImage = clone.querySelector("img");
      const productTitle = clone.querySelector(".product-variant-title");
      productTitle.innerText = title;
      firstImage.src = `https:${imageUrl}`;
      if (freeGiftNode) freeGiftNode.remove();
      
      clone.classList.add("active", "h-20", "bundle-progress__item", "has-item", "flex");
      clone.removeAttribute("id");
      clone.removeAttribute("style");
      
      const removeButton = clone.querySelector(".bundle-progress__item__remove");
      removeButton.classList.remove("hide");
      removeButton.addEventListener("click", () => {
        this.parent.removeFromBundle(node.buttonElement);
      });
      
      newNodesArr.push(clone);
    });

    while (newNodesArr.length < 5) {
      const clone = this.shadowLi.cloneNode(true);
      const variantNode = clone.querySelector(".product-variant-name");
      const priceNode = clone.querySelector(".product-variant-price");
      priceNode.remove();
      variantNode.remove();
      clone.classList.add("h-20", "bundle-progress__item", "flex");
      clone.removeAttribute("id");
      clone.removeAttribute("style");

      const freeGiftNode = clone.querySelector(".free-gift");
      const position = newNodesArr.length;
      
      if (freeGiftNode) {
        if (position === 0) {
          freeGiftNode.remove();
        } else if (position === 1) {
          freeGiftNode.textContent = `Unlock ${this.discountRates.two * 100}% off`;
        } else if (position === 2) {
          freeGiftNode.textContent = `Unlock ${this.discountRates.three * 100}% off`;
        } else if (position === 3) {
          freeGiftNode.textContent = `Unlock ${this.discountRates.four * 100}% off`;
        } else {
          freeGiftNode.textContent = this.unlockTexts.gift;
        }
      }
      
      newNodesArr.push(clone);
    }

    if (this.itemsIdsInBundle.length === 5) {
      const targetNode = this.bundleFreeItem;
      const node = targetNode.querySelector(".add-to-bundle");
      const clone = this.shadowLi.cloneNode(true);
      
      const title = node.getAttribute("data-product-title");
      const imageUrl = node.getAttribute("data-product-image-url");
      const productVariantName = node.getAttribute("data-product-variant-name");
      const productPrice = node.getAttribute("data-product-price");
      
      const productVariantNode = clone.querySelector(".product-variant-name");
      const productVariantPriceNode = clone.querySelector(".product-variant-price");
      const freeGiftNode = clone.querySelector(".free-gift");
      
      // productVariantPriceNode.innerHTML = `<span class="product-bundle-free-price">${productPrice}</span><span>FREE</span>`;
      productVariantPriceNode.innerHTML = `<span>FREE</span>`;
      freeGiftNode.textContent = '';
      if (productVariantName) {
        productVariantNode.innerText = productVariantName;
      } else {
        productVariantNode.remove();
      }
      
      const firstImage = clone.querySelector("img");
      const productTitle = clone.querySelector(".product-variant-title");
      productTitle.innerText = title;
      firstImage.src = `https:${imageUrl}`;
      
      clone.classList.add("h-20", "bundle-progress__item", "flex");
      clone.removeAttribute("id");
      clone.removeAttribute("style");
      
      const progressTail = document.querySelector(".bundle-progress-bar__item.tail");
      const cloned = progressTail.previousElementSibling.cloneNode(true);
      const circleImage = cloned.querySelector(".gift-active");
      circleImage.innerHTML = "FREE";
      cloned.classList.add("before-tail");
      progressTail.parentNode.insertBefore(cloned, progressTail);
      
      this.progressBarItems = document.querySelectorAll(".bundle-progress-bar__item");
      newNodesArr.push(clone);
    }

    this.progressItemsContainer.innerHTML = "";
    newNodesArr.forEach((node) => this.progressItemsContainer.appendChild(node));
    this.adjustTransitions(this.itemsIdsInBundle.length - 1, true);
    this.calculateCartTotal();
    return this.itemsIdsInBundle || [];
  }

  removeFromBundle(buttonElement) {
    const id = buttonElement.getAttribute("data-product-id");
    const targetIndex = this.itemsIdsInBundle.reduceRight(
      (acc, item, index) => (item.id === id && acc === -1 ? index : acc),
      -1
    );
    
    if (targetIndex !== -1) {
      this.itemsIdsInBundle.splice(targetIndex, 1);
    }

    const newNodesArr = [];
    
    this.itemsIdsInBundle.forEach((node, index) => {
      const clone = this.shadowLi.cloneNode(true);
      const title = node.buttonElement.getAttribute("data-product-title");
      const imageUrl = node.buttonElement.getAttribute("data-product-image-url");
      const productVariantName = node.buttonElement.getAttribute("data-product-variant-name");
      const productPrice = node.buttonElement.getAttribute("data-product-price");
      
      const productVariantNode = clone.querySelector(".product-variant-name");
      const productVariantPriceNode = clone.querySelector(".product-variant-price");
      const freeGiftNode = clone.querySelector(".free-gift");
      
      const discount = this.itemsIdsInBundle.length >= 4 ? this.discountRates.four : 
                      this.itemsIdsInBundle.length >= 3 ? this.discountRates.three :
                      this.itemsIdsInBundle.length >= 2 ? this.discountRates.two : 0;

      const originalPrice = parseFloat(productPrice.replace(/[^\d.-]/g, ""));
      const discountedPrice = originalPrice * (1 - discount);
      const currencySymbol = productPrice[0];
      const currencyCode = productPrice.split(" ").pop();

      if (discount > 0) {
        productVariantPriceNode.innerHTML = `
          <span class="font-extralight text-base line-through text-gray-400">${productPrice}</span>
          <span class="font-extralight text-base">${currencySymbol}${discountedPrice.toFixed(2)} ${currencyCode}</span>
        `;
      } else {
        productVariantPriceNode.innerText = productPrice;
      }
      
      if (productVariantName) {
        productVariantNode.innerText = productVariantName;
      } else {
        productVariantNode.remove();
      }
      
      const firstImage = clone.querySelector("img");
      const productTitle = clone.querySelector(".product-variant-title");
      productTitle.innerText = title;
      firstImage.src = `https:${imageUrl}`;
      
      if (freeGiftNode) freeGiftNode.remove();
      
      clone.classList.add("active", "h-20", "bundle-progress__item", "has-item", "flex");
      clone.removeAttribute("id");
      clone.removeAttribute("style");
      
      const removeButton = clone.querySelector(".bundle-progress__item__remove");
      removeButton.classList.remove("hide");
      removeButton.addEventListener("click", () => {
        this.parent.removeFromBundle(node.buttonElement);
      });
      
      newNodesArr.push(clone);
    });

    while (newNodesArr.length < 5) {
      const clone = this.shadowLi.cloneNode(true);
      const variantNode = clone.querySelector(".product-variant-name");
      const priceNode = clone.querySelector(".product-variant-price");
      
      priceNode.remove();
      variantNode.remove();
      
      clone.classList.add("h-20", "bundle-progress__item", "flex");
      clone.removeAttribute("id");
      clone.removeAttribute("style");

      const freeGiftNode = clone.querySelector(".free-gift");
      const position = newNodesArr.length;
      
      if (freeGiftNode) {
        if (position === 0) {
          freeGiftNode.remove();
        } else if (position === 1) {
          freeGiftNode.textContent = `Unlock ${this.discountRates.two * 100}% off`;
        } else if (position === 2) {
          freeGiftNode.textContent = `Unlock ${this.discountRates.three * 100}% off`;
        } else if (position === 3) {
          freeGiftNode.textContent = `Unlock ${this.discountRates.four * 100}% off`;
        } else {
          freeGiftNode.textContent = this.unlockTexts.gift;
        }
      }
      
      newNodesArr.push(clone);
    }

    const beforeTail = document.querySelector(".before-tail");
    if (beforeTail) {
      beforeTail.remove();
      this.progressBarItems = document.querySelectorAll(".bundle-progress-bar__item");
    }

    this.progressItemsContainer.innerHTML = "";
    newNodesArr.forEach((node) => this.progressItemsContainer.appendChild(node));
    this.adjustTransitions(this.itemsIdsInBundle.length - 1, false);
    this.calculateCartTotal();
    return this.itemsIdsInBundle || [];
  }

  calculateCartTotal() {
    const sumPrices = (items) => {
      if (!items.length) {
        return {
          total: "$0.00 AUD",
          originalTotal: "$0.00 AUD",
          discount: 0
        };
      }
      let freeItem = items.length === 5 ? true : false;
      // If we have 5 items, get the free item price
      let freeItemPrice = 0;
      if (freeItem) {
        // Find the free item in the bundle
        const freeItemElement = document.getElementById("bundle-target-item");
        if (freeItemElement) {
          freeItemPrice = freeItemElement.getAttribute("data-product-price-without-currency");
          // if the free item is a variant, it will return 0 here, so we need to get the price from the actual variant
          // actually looks like the without-currency flag is not working from Liquid in the price-bundle snippet,so we need to get the price from the variant
          if (freeItemPrice != "0.00") {
            freeItemPrice = parseFloat(freeItemPrice.trim());
          } else {
            const freeItemVariantElement = freeItemElement.querySelector(`[data-product-id="${freeItemElement.dataset.productId}"]`);
            const freeItemVariantPrice = freeItemVariantElement.getAttribute("data-product-price");  
            freeItemPrice = parseFloat(freeItemVariantPrice.replace(/[^\d.-]/g, ""));
          }

        }
      }

      const firstPrice = items[0].buttonElement.getAttribute("data-product-price");
      const currencySymbol = firstPrice[0];
      const currencyCode = firstPrice.split(" ").pop();

      let originalTotal = 0;
      items.forEach((item) => {
        const price = item.buttonElement.getAttribute("data-product-price");
        const value = parseFloat(price.replace(/[^\d.-]/g, ""));
        originalTotal += value;
      });

      const discountRate = this.calculateDiscount(items.length);
      const discountedTotal = originalTotal * (1 - discountRate);

      const originalTotalWithFreeItem = originalTotal + freeItemPrice;

      return {
        total: `${currencySymbol}${discountedTotal.toFixed(2)} ${currencyCode}`,
        originalTotal: `${currencySymbol}${originalTotalWithFreeItem.toFixed(2)} ${currencyCode}`,
        discount: discountRate
      };
    };

    const result = sumPrices(this.itemsIdsInBundle);
    
    if (this.itemsIdsInBundle.length > 0) {
      this.dataBundleButtonCaption.innerText = "Add bundle to cart";
      this.bundleAddToCartButton.classList.add("active");

      if (this.itemsIdsInBundle.length >= 2) {
        const discount = result.discount * 100;
        const savings = parseFloat(result.originalTotal.replace(/[^\d.-]/g, "")) - 
                       parseFloat(result.total.replace(/[^\d.-]/g, ""));
        const currencySymbol = result.total[0];
        const currencyCode = result.total.split(" ").pop();
        
        this.dataBundleButtonPrice.innerHTML = `
          <span>${result.total}</span>
          <span class="font-extralight text-base line-through ml-2 text-gray-500">${result.originalTotal}</span>
        `;

        const totalValue = parseFloat(result.total.replace(/[^\d.-]/g, ""));
        const additionalAmount = totalValue >= this.freeShippingPrice ? this.shippingRate : 0;
        const freeShippingText = totalValue >= this.freeShippingPrice ? ' + free shipping' : '';

          this.dataBundleTotalAmount.innerHTML = `
            <span class="text-green-600">${discount > 0 ? `${discount}% off${freeShippingText}: ` : ''}Save ${currencySymbol}${(savings + additionalAmount).toFixed(2)} ${currencyCode}</span>
          `;

        
      } else {
        this.dataBundleButtonPrice.innerText = result.total;
        this.dataBundleTotalAmount.innerHTML = '';
      }
    } else {
      this.dataBundleButtonCaption.innerText = "Select your items";
      this.bundleAddToCartButton.classList.remove("active");
      this.dataBundleButtonPrice.innerText = result.total;
      this.dataBundleTotalAmount.innerHTML = '';
    }
  }

}
customElements.define("bundle-cart", BundleCart);
